import { render } from "./poll.vue?vue&type=template&id=37c2143c"
import script from "./poll.js?vue&type=script&lang=js&external"
export * from "./poll.js?vue&type=script&lang=js&external"

import "./poll.vue?vue&type=style&index=0&id=37c2143c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__